var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrowthListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0192 3.71959C14.0192 -2.21522 0 -0.159063 0 3.71959V8.39267C0 12.2713 3.13096 15.4023 7.00962 15.4023C10.8883 15.4023 14.0192 12.2713 14.0192 8.39267V3.71959Z",
    fill: "#CFABFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4873 4.20581L6.09059 8.44391L3.99894 6.42773L2.80371 7.57983L6.09059 10.7481L11.6826 5.35792L10.4873 4.20581Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthListIcon);
export default __webpack_public_path__ + "static/media/growth_list_icon.9e238d1dc9dc49a070481b8208feb4a0.svg";
export { ForwardRef as ReactComponent };